/* =================================== Planet Action ========================== */

export const SET_CURRENT_PLANET = 'SET_CURRENT_PLANET'

/* =================================== AUTH Actions =========================== */

export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'

/* =================================== Notification Actions ========================== */

export const NOTIFICATION_OPEN = 'NOTIFICATION_OPEN'
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE'

/* =================================== LOGIN Actions ========================== */

export const LOGIN_START = 'LOGIN_START'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'

/* =================================== LOGOUT Action ========================== */

export const LOGOUT = 'LOGOUT'

/*  ================================== Pool Info =============================== */

export const POOL_LOADING = 'POOL_LOADING'
export const UPDATE_POOL_INFO = 'UPDATE_POOL_INFO'
export const UPDATE_POOL_DATA = 'UPDATE_POOL_DATA'
export const POOL_LOADING_NEW = 'POOL_LOADING_NEW'
export const UPDATE_POOL_INFO_NEW = 'UPDATE_POOL_INFO_NEW'
export const UPDATE_POOL_DATA_NEW = 'UPDATE_POOL_DATA_NEW'
export const UPDATE_ONLY_POOL_DATA = 'UPDATE_ONLY_POOL_DATA'
export const UPDATE_ONLY_VAULTS_DATA = 'UPDATE_ONLY_VAULTS_DATA'
export const UPDATE_POOL_INFO_V3 = "UPDATE_POOL_INFO_V3"
export const UPDATE_POOL_DATA_V3 = "UPDATE_POOL_DATA_V3"

/*  ================================== Portfolio data =============================== */

export const PORTFOLIO_LOADING = 'PORTFOLIO_LOADING'
export const UPDATE_USER_PORTFOLIO = 'UPDATE_USER_PORTFOLIO'

/* =================================== Platform Action ========================== */

export const PLATFORM_LOADING = 'PLATFORM_LOADING'
export const UPDATE_PLATFORM_DATA = 'UPDATE_PLATFORM_DATA'

/* =================================== Infinity Vault Action ========================== */

export const INFINITY_VAULT_LOADING = 'INFINITY_VAULT_LOADING'
export const INFINITY_VAULT_LOADING_NEW = 'INFINITY_VAULT_LOADING_NEW'
export const UPDATE_GAMMA_INF_VAULT_DATA = 'UPDATE_GAMMA_INF_VAULT_DATA'
export const UPDATE_AQUA_INF_VAULT_DATA = 'UPDATE_AQUA_INF_VAULT_DATA'
export const UPDATE_GAMMA_INF_VAULT_DATA_NEW = 'UPDATE_GAMMA_INF_VAULT_DATA_NEW'
export const UPDATE_AQUA_INF_VAULT_DATA_NEW = 'UPDATE_AQUA_INF_VAULT_DATA_NEW'
export const GAMMA_INFINITY_VAULT_LOADING = 'GAMMA_INFINITY_VAULT_LOADING'
export const AQUA_INFINITY_VAULT_LOADING = 'AQUA_INFINITY_VAULT_LOADING'

/* =================================== Wallet Actions =========================== */

export const CONNECT_ETH_WALLET = 'CONNECT_ETH_WALLET'
export const DISCONNECT_ETH_WALLET = 'DISCONNECT_ETH_WALLET'

/* =================================== Platform data Actions =========================== */

export const GET_PLATFORM_DATA_START = 'GET_PLATFORM_DATA_START'
export const GET_PLATFORM_DATA_SUCCESS = 'GET_PLATFORM_DATA_SUCCESS'
export const GET_PLATFORM_DATA_FAIL = 'GET_PLATFORM_DATA_FAIL'


/* ======================================== Lending Action ================================== */


/* =================================== Base Action =================================== */

export const ADD_NULL_LOADING = 'ADD_NULL_LOADING'
export const LENDING_PLATFORM_LOADING = 'LENDING_PLATFORM_LOADING'
export const LENDING_PLATFORM_LOADING_NEW = 'LENDING_PLATFORM_LOADING_NEW'
export const UPDATE_LENDING_PLATFORM_DATA = 'UPDATE_LENDING_PLATFORM_DATA'
export const UPDATE_NEW_LENDING_PLATFORM_DATA = 'UPDATE_NEW_LENDING_PLATFORM_DATA'

export const USER_ASSET_LOADING = 'USER_ASSET_LOADING'
export const UPDATE_USER_ASSET_DATA = 'UPDATE_USER_ASSET_DATA'
export const UPDATE_USER_OLD_ASSET_DATA = 'UPDATE_USER_OLD_ASSET_DATA'
export const USER_ASSET_LOADING_NEW = 'USER_ASSET_LOADING_NEW'


export const MARKET_ASSET_LOADING = 'MARKET_ASSET_LOADING'
export const UPDATE_ASSET_MARKET_DATA = 'UPDATE_ASSET_MARKET_DATA'

export const BORROW_LIMIT_LOADING = 'BORROW_LIMIT_LOADING'
export const UPDATE_BORROW_LIMIT = 'UPDATE_BORROW_LIMIT'
export const BORROW_LIMIT_LOADING_NEW = 'BORROW_LIMIT_LOADING_NEW'
export const UPDATE_BORROW_LIMIT_NEW = 'UPDATE_BORROW_LIMIT_NEW'

export const EARNING_LOADING = 'EARNING_LOADING'






export const UPDATE_EARNING = 'UPDATE_PENDING_EARNING'

/* =================================== Treasury Balance  =========================== */

export const TREASURY_BALANCE_LOADING = 'TREASURY_BALANCE_LOADING'
export const UPDATE_TREASURY_BALANCE = 'UPDATE_TREASURY_BALANCE'

/* =================================== Market data ================================= */

/* =================================== Platform Action ========================== */

export const MARKET_DATA_LOADING = 'MARKET_DATA_LOADING'
export const UPDATE_MARKET_DATA = 'UPDATE_MARKET_DATA'
